import { render, staticRenderFns } from "./putaway.vue?vue&type=template&id=348a903b&"
import script from "./putaway.vue?vue&type=script&lang=js&"
export * from "./putaway.vue?vue&type=script&lang=js&"
import style0 from "./putaway.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports